import styled from 'styled-components';

import { InputWrapper } from '@/core/components/InputWrapper';

interface FormSelectProps {
  backgroundcolor: string;
  error: () => string | false;
  isDisabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onFocus: () => void;
  name: string;
  options: Array<string>;
  value: string | undefined;
}

export const Select = styled.select`
  background-color: #fff !important;
  color: ${props => (props.value ? 'black' : 'rgba(0, 0, 0, 0.5)')};
`;

export const FormSelect = ({
  backgroundcolor,
  error,
  isDisabled,
  onChange,
  onFocus,
  options,
  value,
  name,
}: FormSelectProps) => (
  <InputWrapper
    backgroundcolor={backgroundcolor}
    error={error}
  >
    <Select
      aria-label={name}
      disabled={isDisabled}
      name={name}
      onChange={event => onChange(event)}
      onFocus={() => onFocus()}
      value={value}
    >
      <option
        value=""
        disabled
        hidden
      >
        {name}
      </option>
      {options?.map(option => (
        <option
          key={option}
          value={option}
        >
          {option}
        </option>
      ))}
    </Select>
  </InputWrapper>
);

FormSelect.defaultProps = {
  isDisabled: false,
};
